var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.8,24.5c0,.4-.3.8-.8.8H5c-2.6,0-4.8-2.1-4.8-4.8V1.5c0-.4.3-.8.8-.8s.8.3.8.8v16.1l4-5.7c-.4-.5-.7-1.2-.7-2,0-1.7,1.3-3,3-3s3,1.3,3,3-.2,1.2-.5,1.7l3.2,3.6c.4-.2.9-.3,1.3-.3s.5,0,.8.1l4.1-7c-.5-.5-.9-1.3-.9-2.1,0-1.7,1.3-3,3-3s3,1.3,3,3-1.3,3-3,3-.5,0-.8-.1l-4.1,7c.5.5.9,1.3.9,2.1,0,1.7-1.3,3-3,3s-3-1.3-3-3,.2-1.2.5-1.7l-3.2-3.6c-.4.2-.9.3-1.3.3s-.7,0-1-.2l-5.2,7.4v.2c0,1.8,1.5,3.2,3.2,3.2h20c.4,0,.8.3.8.8Z",
    stroke: "#000000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVps);
export default __webpack_public_path__ + "static/media/vps.ede4548c00092dc99537c3aa7fb31c56.svg";
export { ForwardRef as ReactComponent };